import { Component, createElement } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import some from 'lodash/some'
import { connectGetters } from 'react-redux-getters'
import { getPermissions } from 'selectors/permissions'
import { openUnlockFeatureDialog } from './actions'

const mapDispatchToProps = {
  openUnlockFeatureDialogAction: openUnlockFeatureDialog
}

const mapGettersToProps = state => ({
  permissionsGetter: getPermissions(state)
})

export default options => WrappedComponent => (
  @connect(null, mapDispatchToProps, null, options)
  @connectGetters(mapGettersToProps)
  class WithUnlockFeatureDialog extends Component {
    static propTypes = {
      openUnlockFeatureDialogAction: PropTypes.func.isRequired,
      permissionsGetter: PropTypes.object.isRequired,
    }

    openUnlockFeatureDialog = (...permissions) => {
      const { openUnlockFeatureDialogAction, permissionsGetter } = this.props

      const shouldOpen = !permissions.length
        || some(permissions, permission => !permissionsGetter.data[permission])

      if (shouldOpen) openUnlockFeatureDialogAction()
      return shouldOpen
    }

    render() {
      return createElement(WrappedComponent, {
        ...this.props,
        openUnlockFeatureDialog: this.openUnlockFeatureDialog
      })
    }
  }
)
